import { optionsPopupWith } from './popups/OptionsPopup';

export const accountPlanChangedPopup = () => optionsPopupWith(
    'Account Plan Has Changed',
    'The plan your account on has changed.  For these changes to take effect the application must reload.', [
    [true, 'Okay', 'primary', 'confirm'],
]);
